$(function(){
    $('.js-tab-title').on('click', function(){
        $('.additional-tabs__item-content-wrapper', this).slideToggle();
        $('.js-open', this).toggleClass('d-none');
        $('.js-close', this).toggleClass('d-none');
    })


    $('.js-tab-title-desktop').on('click', function(e){
        e.preventDefault();
        var dataID = $(this).data('id');
        $('.js-tab-title-desktop').removeClass('btn--active');
        $(this).addClass('btn--active');
        $('.additional-tabs__item-content').addClass('d-none');
        $('.additional-tabs__item-content[data-target="'+dataID+'"]').toggleClass('additional-tabs--active d-none');

    })

})